/* eslint-disable functional/type-declaration-immutability -- this is a special case of token aliases that immutability isn't worth my time */
import { DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { BasePortalOutlet } from '@angular/cdk/portal';
import { Injector } from '@angular/core';

export class ApDialogConfig<
  TComponent = unknown,
  TData = unknown,
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- This is not unnecessary, I want to be able to specify the type here
  TInitialState = Record<string, unknown>,
  // we are not using the TCloseResult passed into DialogRef.close(),
  // because we have our own result handling thru ApActiveModal
  TCloseResult = unknown,
  C extends BasePortalOutlet = BasePortalOutlet,
> extends DialogConfig<TData, DialogRef<TCloseResult, TComponent>, C> {
  // This property allows backwards compatibility with old modals.
  // injector that can provide $scope for UpgradeComponents
  elementInjector?: Injector;

  // This property allows backwards compatibility with old modals.
  // Use 'data' property instead for anything new.
  initialState?: TInitialState;
}

export interface ApDialogRef<TComponent = unknown, TCloseResult = unknown> extends DialogRef<TCloseResult, TComponent> {
  readonly config: ApDialogConfig<TComponent, unknown, unknown, TCloseResult>;
}
